import React from 'react'
import { useCart } from 'react-use-cart';
import Header from '../Header/Header';
import { dataList } from '../Shop/constants';
import style from "./Cart.module.css"

const Cart = () => {
  const { dataList, isEmpty, totalUniqueItems, updateItemQuantity, removeItem, emptyCart } = useCart();
  if (isEmpty) return <p>Your cart is empty</p>
  let total = 0;


  return (
    <div>
      
      {dataList.map((item) => {
        if (item.count >= 1) {
          const totalPrice = item.count * item.price;
          total += totalPrice;
          return (
            <>
              <img src={item.img} alt="" />
              <h1 key={item.id}>{item.title}</h1>
              <button onClick={() => updateItemQuantity(item.id, item.count--)}>-</button>
              {item.count}
              <button onClick={() => updateItemQuantity(item.id, item.count++)}>+</button>
              <h1>{totalPrice}$</h1>
              <button onClick={() => removeItem(item.id)}>Remove</button>
            </>
          )
        }
        else {
          removeItem(item.id)
        }
      })}
      <h1>{total}$</h1>
      <button onClick={emptyCart}>empty</button>
    </div>
  )
}

export default Cart;